import { Order, VisibleColumnSpec } from "@/types";

export const DEFAULT_ORDER_COLUMNS: VisibleColumnSpec<
  Order,
  "actions" | "icon" | "product" | "contract" | "lastPrice"
>[] = [
  "icon",
  "id",
  "created",
  "contract",
  { id: "salesItem", breakpoint: "mantine-visible-from-xl" },
  "product",
  "company",
  { id: "amount", breakpoint: "mantine-visible-from-sm" },
  { id: "remainingAmount", breakpoint: "mantine-visible-from-lg" },
  { id: "finalAmount", breakpoint: "mantine-visible-from-xl" },
  "status",
  { id: "lastPrice", breakpoint: "mantine-visible-from-lg" },
  { id: "fullLoad", breakpoint: "mantine-visible-from-lg" },
  // { id: "orderCurrency", breakpoint: "mantine-visible-from-lg" },
  // Replace <CURRENCY> with the runtime currency (e.g. `totalPriceWithFee.EUR`)
  "actions",
];
